import React, { PureComponent } from "react";
import classnames from "classnames";

import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/Info";

import { constructError } from "../services/errors.js";

import "./I18n.css";

export default class I18n extends PureComponent {
  changeLang = (event, value) => {
    const { onlyFr, changeLang } = this.props;

    if (!onlyFr) {
      changeLang(value);
    }
  };

  renderI18n() {
    const {
      hideLabel,
      elements,
      lang,
      errors,
      changeFields,
      emptyElement
    } = this.props;
    const tmpInfos = elements !== undefined ? elements[lang] : emptyElement;
    const i18n = tmpInfos !== undefined ? tmpInfos : emptyElement;

    const errorLang = errors && errors[lang];
    return (
      <div>
        <div>
          {!hideLabel && (
            <FormControl
              margin="normal"
              fullWidth
              error={
                errorLang &&
                errorLang["label"] &&
                Object.keys(errorLang).length > 0
              }
            >
              <InputLabel htmlFor="label">Libellé</InputLabel>
              <Input
                id="label"
                value={i18n.label}
                onChange={changeFields("label")}
              />
              <FormHelperText>
                {errorLang && constructError(errorLang["label"])}
              </FormHelperText>
            </FormControl>
          )}
          <FormControl
            margin="normal"
            fullWidth
            error={
              errorLang &&
              errorLang["description"] &&
              Object.keys(errorLang).length > 0
            }
          >
            <InputLabel htmlFor="description" placeholder="Description">
              Description
            </InputLabel>
            <Input
              id="description"
              multiline
              rows="4"
              value={i18n.description}
              onChange={changeFields("description")}
            />
            <FormHelperText>
              {errorLang && constructError(errorLang["description"])}
            </FormHelperText>
          </FormControl>
        </div>
        <div className="sp-i18n--specificfields">{this.props.children}</div>
      </div>
    );
  }
  renderTab(lang) {
    const { onlyFr } = this.props;
    const disabled = onlyFr && lang.code !== "fr";
    const tabClasses = classnames({
      "sp-i18n--tab__disabled": disabled
    });

    return (
      <Tab
        key={lang.code}
        className={tabClasses}
        value={lang.code}
        label={lang.label}
        disableRipple={disabled}
        icon={
          disabled ? (
            <Tooltip
              title="Validez une première fois avant de pouvoir modifier les autres langues"
              placement="top"
            >
              <InfoIcon />
            </Tooltip>
          ) : (
            undefined
          )
        }
      />
    );
  }
  render() {
    const { langs, lang, className } = this.props;

    return (
      <Typography component="div" className={className}>
        <Tabs value={lang} onChange={this.changeLang}>
          {langs.map(l => this.renderTab(l))}
        </Tabs>
        {this.renderI18n()}
      </Typography>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components-utils/I18n.js